"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagRW = function FlagRW(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6,12.18H-193V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,12.18H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,139.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "135.18",
    width: "409.6",
    height: "67.09",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94,146.36H209.54a7.07,7.07,0,0,0,7.06-7.06v-60H-193v60a7.06,7.06,0,0,0,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M173.57-50.13l28.91-4.78L173.57-59.7l24.87-15.48-28.53,6.64L187-92.36l-23.82,17,6.64-28.53L154.3-79l-4.79-28.91L144.73-79l-15.49-24.87,6.64,28.53-23.82-17,17.05,23.82-28.53-6.64L125.45-59.7,96.54-54.91l28.91,4.78L100.58-34.64l28.53-6.64L112.06-17.46l23.82-17.06L129.24-6l15.48-24.87,4.79,28.9,4.79-28.9L169.78-6l-6.64-28.53,23.82,17L169.91-41.28l28.53,6.64ZM149.51-37.25a17.66,17.66,0,0,1-17.65-17.66,17.66,17.66,0,0,1,17.65-17.66,17.66,17.66,0,0,1,17.65,17.66,17.66,17.66,0,0,1-17.65,17.66Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M162.75-54.91a13.24,13.24,0,0,1-13.24,13.24,13.24,13.24,0,0,1-13.24-13.24,13.24,13.24,0,0,1,13.24-13.24,13.24,13.24,0,0,1,13.24,13.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagRW;
exports["default"] = _default;